/* eslint-disable */
import React from 'react';
import { MDBDataTable } from 'mdbreact';
class Tables extends React.Component {
    constructor(props) {
        super(props);
        const columns = [
            {
                label: 'Name',
                field: 'name',
                sort: 'asc',
            },
            {
                label: 'Hourly Pricing',
                field: 'hourlyPricing',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Monthly Pricing',
                field: 'monthlyPricing',
                sort: 'asc',
                width: 150
            },
        ];
        this.props.onlyMonthly && columns.splice(1, 1);
        console.log(columns)
        const rows = this.props.data;
        const dataUpdated = {
            columns,
            rows
        }
        this.state = {
            data : dataUpdated,
            mobile: false,
        }
    }
    componentDidMount() {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({ mobile: true });
        }
    }
    render() {
        const { mobile } = this.state

        return (
            <div className='tabsData custom-table'>
                <MDBDataTable
                    responsive
                    striped
                    bordered
                    small
                    headCheckboxID='id3'
                    bodyCheckboxID='checkboxes3'
                    data={{ columns: this.state.data.columns, rows: this.state.data.rows }} />
            </div >
        );
    }
}
export default Tables;